import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface IIndexingDetails {
  message: string;
  showIndexBanner: boolean;
}

export interface IRetryCustodian {
  id: number;
  name: string;
}

export interface IRetryField {
  name: string;
  type: string;
  description: string;
  cases: string[] | null;
  length: number | null;
  dateTimeFormat: number | null;
  isCustom: boolean;
  isExportableForReview: boolean;
}

export interface IRetryData {
  custodians: IRetryCustodian[];
  fields: IRetryField[];
}

interface IReRunFailedModel {
  showpopup: boolean; // A single boolean flag to control popup visibility
  dataSetName?: string;
  indexId: number;
  ecaNlpingestionId?: number;
  datFilePath?: string;
  mediaId?: number;
  exportId?: number;
  overlayRetryData?: IRetryData;
}

interface ICreateCustomIndex {
  customIndex: string;
  savedSearch: string;
}

interface IIndexingState {
  indexBannerData: IIndexingDetails;
  showReRunFailedPopup: IReRunFailedModel;
  customIndexData: ICreateCustomIndex;
}

const initialState: IIndexingState = {
  indexBannerData: {
    message: '',
    showIndexBanner: false,
  },
  showReRunFailedPopup: {
    showpopup: false, // Initial state of showReRunPopup
    dataSetName: '',
    indexId: 0,
    overlayRetryData: undefined,
  },
  customIndexData: {
    customIndex: '',
    savedSearch: '',
  },
};

const IndexingManagementSlice = createSlice({
  name: 'indexingManagement',
  initialState,
  reducers: {
    setIndexingBannerData(state, action: PayloadAction<IIndexingDetails>) {
      state.indexBannerData = action.payload;
    },
    setCustomIndexData(state, action: PayloadAction<ICreateCustomIndex>) {
      state.customIndexData = action.payload;
    },
    setReRunPopup(state, action: PayloadAction<IReRunFailedModel>) {
      state.showReRunFailedPopup = action.payload;
    },
  },
});

export const {setIndexingBannerData, setReRunPopup, setCustomIndexData} =
  IndexingManagementSlice.actions;

export default IndexingManagementSlice.reducer;
